import { render, staticRenderFns } from "./TimeToTake.vue?vue&type=template&id=26ae7f9e&lang=html"
import script from "./TimeToTake.vue?vue&type=script&lang=js"
export * from "./TimeToTake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports